
import React, { useContext, useState } from 'react'
import { Icon } from 'antd'
import LayoutContext from '../../LayoutContext'
import { appModule } from 'services/module'
import { Link } from 'react-router-dom'


export const SiderModule = () => {
  const { collapsed } = useContext(LayoutContext)
  let groupList = appModule.getModule()

  const [currGroupKey, setCurrGroupKey] = useState(appModule.getCurrGroupCodeByPath());

  const renderLink = (moduleVo: ModuleVo,shrink?:boolean) =>{
    let className = shrink?'app-module-item-link-shrink':'app-module-item-link';
    return <Link
              className={className}
              to={moduleVo.url!}
              replace={moduleVo.url === window.location.pathname}
              onClick={()=>appModule.setCurrModule(moduleVo)}
              >
              <span>{moduleVo.name}</span>
            </Link>
  }

  const renderShrink = () => {
    return (
      <div className="shrink-menu">
        {
          groupList.map((g: ModuleGroupVo) => {
            return (
              <div className="shrink-menu-item" key={g.fullCode}>
                <div className="shrink-menu-item-icon">
                  <span className={g.icon}></span>
                </div>
                <ul>
                  {g.moduleList.map((m: ModuleVo) => {
                    return <li key={m.fullCode}>{renderLink(m, true)}</li>
                  })}
                </ul>
              </div>
            )
          })
        }
      </div>
    )
  }

  const renderExpand = () => {
    return (
      <div className="expand-menu">
        {
          groupList.map((g: ModuleGroupVo) => {
            let isCurrent = g.fullCode === currGroupKey;
            return (
              <div className={`expand-menu-list  ${isCurrent ? "active" : ''}`}
                key={g.fullCode}
                onClick={() => setCurrGroupKey(g.fullCode)}>
                {isCurrent ? <div className="active"></div> : ''}
                <div className="expand-menu-list-header">
                  <span className="expand-menu-list-icon1">
                    <span className={g.icon}></span>
                  </span>
                  <div className="expand-menu-list-title" >
                    {g.name}
                  </div>
                  <span className="expand-menu-list-icon2">
                    <Icon
                      type={isCurrent ? 'up' : 'down'}
                      style={{ color: 'white' }}
                    />
                  </span>
                </div>
                {
                  isCurrent ?
                    <ul>
                      {g.moduleList.map((c: ModuleVo) => {
                        return <li key={c.fullCode}>{renderLink(c, false)}</li>
                      })}
                    </ul>
                    : <React.Fragment />
                }
              </div>
            )
          })
        }
      </div>
    )
  }

  return (
    <div className="app-index-menu">
      <div className='app-index-menu-split'>
        <div className='app-index-menu-split-line'></div>
      </div>
      {collapsed ? renderShrink() : renderExpand()}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/layouts/components/SiderMenu/SiderModule.tsx